import React, { Component } from 'react';
import { TransactionJsonModel } from '../../domain/stream/transaction/TransactionDomains';
import { User } from '../../domain/rbac/RbacDomains';
import Icon from 'icons/Icon';
import LanguageUtil from 'util/LanguageUtil';
import GatewayContainer from 'config/GatewayContainer';
import GatewayNames from 'constant/GatewayNames';
import SandboxClient, { TestResultsResponse } from 'client/sandbox/SandboxClient';
import SandboxDatabaseContainer from './SandboxDatabaseContainer';
import SandboxHistoricalSidebar from './SandboxHistoricalSidebar';
import RuleClient from 'client/rule/RuleClient';
import MessageUtil from 'util/MessageUtil';
import CustomTable from 'components/custom/CustomTable';
import CustomTableContentWrapper from 'components/custom/CustomTableContentWrapper';
import { connect } from 'react-redux';
import { RootState } from '../../redux/store';
import { RuleJsonModel } from 'domain/collection/rule/FlowDomains';

class SandboxHistoricalContainer extends Component<Props, State> {
  public state = new State();

  private sandboxClient: SandboxClient = GatewayContainer.getInstance().get(GatewayNames.SANDBOX_CLIENT);
  private ruleClient: RuleClient = GatewayContainer.getInstance().get(GatewayNames.RULE_CLIENT);

  render() {
    const { selectedResult, testResults, ruleDetails, ruleTableData } = this.state;
    return (
      <div className={'flex flex-col lg:flex-row w-full overflow-x-hidden h-full py-5 px-5 gap-5 overflow-y-scroll max-h-[calc(100dvh-260px)]'}>
        <div className='flex lg:w-1/4 lg:min-w-[25%] lg:max-w-[25%] w-full h-full order-1 lg:order-0'>
          <div className='flex flex-col w-full gap-4'>
            <button
              onClick={() => this.setState({ selectedResult: undefined, ruleDetails: undefined, ruleTableData: [] })}
              className={`border rounded py-[10px] px-4 w-full h-9 text-sm font-semibold leading-none transition-all duration-200 ${selectedResult ? 'border-f-blue-4 text-f-blue-4 hover:bg-f-blue-4 hover:text-white' : 'bg-main-gray border-f-black-7 text-f-gray-3 cursor-not-allowed'}`}
            >
              {LanguageUtil.get({ id: 'pages.sandbox.historical.createButton', defaultMessage: '+ Create a new test' })}
            </button>
            <SandboxHistoricalSidebar
              testResults={testResults}
              selectedResult={selectedResult}
              setSelectedResult={(selectedResult: TestResultsResponse) => this.setState({ selectedResult })}
            />
          </div>
        </div>
        <div className='flex flex-col w-full h-full lg:pr-5 gap-y-2 lg:order-1 lg:w-3/4 lg:min-w-[75%] lg:max-w-[75%]'>
          {selectedResult && ruleDetails ? (
            <div className='flex flex-col gap-5'>
              <div className='border border-f-black-7 bg-main-gray p-4 rounded-[10px] flex gap-4 flex-col lg:flex-row'>
                <article
                  className='bg-white p-4 rounded-[8px] h-[72px] shadow-[2px_2px_15px_0px_#0000000D] whitespace-nowrap flex items-center gap-3 flex-none'
                  style={{ minWidth: 370 }}
                >
                  <div className='bg-secondary w-10 h-10 rounded-full flex items-center justify-center' style={{ minWidth: '40px', minHeight: '40px' }}>
                    <Icon icon='tracker-click' className='text-primary w-6 h-6' />
                  </div>
                  <div className='flex flex-col gap-1 truncate'>
                    <span className='text-f-black-8 text-xs truncate'>
                      {LanguageUtil.get({ id: 'pages.sandbox.historical.testId', defaultMessage: 'Test ID' })}
                    </span>
                    <span className='text-f-black-2 text-md font-medium truncate'>{selectedResult.id}</span>
                  </div>
                </article>
                {/* <article className="bg-white p-4 rounded-[8px] h-[72px] shadow-[2px_2px_15px_0px_#0000000D] flex items-center gap-3 flex-1 min-w-0">
                                <div className='bg-secondary w-10 h-10 rounded-full flex items-center justify-center' style={{ minWidth: "40px", minHeight: "40px" }}>
                                    <Icon icon="tracker-click" className='text-primary w-6 h-6' />
                                </div>
                                <div className="flex flex-col gap-1 truncate">
                                    <span className='text-f-black-8 text-xs truncate'>
                                        {LanguageUtil.get({id:"pages.sandbox.historical.status",defaultMessage:"Status"})}
                                    </span>
                                    <div className='px-2 py-1 bg-f-green-2 text-f-green-1 h-5 flex items-center gap-1 rounded-full font-medium text-sm'>
                                        <Icon icon="check_circle" className='w-3 h-3' style={{ minWidth: "12px", minHeight: "12px" }} />
                                        {LanguageUtil.get({id:"pages.sandbox.historical.statusInfo.completed",defaultMessage:"Completed"})}
                                    </div>
                                </div>
                            </article> */}
                <article className='bg-white p-4 rounded-[8px] h-[72px] shadow-[2px_2px_15px_0px_#0000000D] flex items-center gap-3 flex-1 min-w-0'>
                  <div className='bg-secondary w-10 h-10 rounded-full flex items-center justify-center' style={{ minWidth: '40px', minHeight: '40px' }}>
                    <Icon icon='tracker-click' className='text-primary w-6 h-6' />
                  </div>
                  <div className='flex flex-col gap-1 truncate'>
                    <span className='text-f-black-8 text-xs truncate'>
                      {LanguageUtil.get({ id: 'pages.sandbox.historical.totalTestCount', defaultMessage: 'Total Test Count' })}
                    </span>
                    <span className='text-f-black-2 text-md font-medium truncate'>{selectedResult.totalCount}</span>
                  </div>
                </article>
                <article className='bg-white p-4 rounded-[8px] h-[72px] shadow-[2px_2px_15px_0px_#0000000D] flex items-center gap-3 flex-1 min-w-0'>
                  <div className='bg-secondary w-10 h-10 rounded-full flex items-center justify-center' style={{ minWidth: '40px', minHeight: '40px' }}>
                    <Icon icon='tracker-click' className='text-primary w-6 h-6' />
                  </div>
                  <div className='flex flex-col gap-1 truncate'>
                    <span className='text-f-black-8 text-xs truncate'>
                      {LanguageUtil.get({ id: 'pages.sandbox.historical.channel', defaultMessage: 'Channel' })}
                    </span>
                    <span className='text-f-black-2 text-md font-medium truncate'>{this.findChannelInWorkflow(ruleDetails[0].workflow)}</span>
                  </div>
                </article>
              </div>
              <CustomTable columns={this.getRuleColumns()} value={ruleTableData} />
            </div>
          ) : (
            <SandboxDatabaseContainer transactions={this.props.transactions} />
          )}
        </div>
      </div>
    );
  }

  getRuleColumns = () => [
    {
      field: 'name',
      header: LanguageUtil.get({ id: 'pages.sandbox.historical.columns.ruleName', defaultMessage: 'Rule Name' }),
      body: (row: RuleTableData) => <CustomTableContentWrapper text={row.name} />,
    },
    {
      field: 'description',
      header: LanguageUtil.get({ id: 'pages.sandbox.historical.columns.description', defaultMessage: 'Description' }),
      body: (row: RuleTableData) => <CustomTableContentWrapper text={row.description || ''} />,
    },
    {
      field: 'priority',
      header: LanguageUtil.get({ id: 'pages.sandbox.historical.columns.priority', defaultMessage: 'Priority' }),
      body: (row: RuleTableData) => <CustomTableContentWrapper text={row.priority?.toString() || ''} />,
    },
    {
      field: 'score',
      header: LanguageUtil.get({ id: 'pages.sandbox.historical.columns.score', defaultMessage: 'Score' }),
      body: (row: RuleTableData) => <CustomTableContentWrapper text={row.score?.toString() || ''} />,
    },
    {
      field: 'hitCount',
      header: LanguageUtil.get({ id: 'pages.sandbox.historical.columns.hitCount', defaultMessage: 'Hit Count' }),
      body: (row: RuleTableData) => <CustomTableContentWrapper text={row.hitCount?.toString() || ''} />,
    },
  ];

  findScoreInWorkflow = (node: any): number | undefined => {
    if (!node) return undefined;
    if (node.value && typeof node.value.score !== 'undefined') {
      return node.value.score;
    }
    if (Array.isArray(node.children)) {
      for (const child of node.children) {
        const score = this.findScoreInWorkflow(child);
        if (typeof score !== 'undefined') {
          return score;
        }
      }
    }
    return undefined;
  };

  findChannelInWorkflow = (node: any): string | undefined => {
    if (!node) return undefined;
    if (node.value && node.value.type === 'Event' && typeof node.value.name === 'string') {
      return node.value.name;
    }
    if (Array.isArray(node.children)) {
      for (const child of node.children) {
        const channel = this.findChannelInWorkflow(child);
        if (typeof channel !== 'undefined') {
          return channel;
        }
      }
    }
    return undefined;
  };

  async componentDidMount() {
    const testResults = (await this.sandboxClient.testResults()) as TestResultsResponse[];
    this.setState({ testResults });
  }

  async componentDidUpdate(prevProps: Props, prevState: State) {
    const { selectedResult } = this.state;
    const { user } = this.props;
    if (prevState.selectedResult !== selectedResult && selectedResult) {
      try {
        const ruleDetails = await this.ruleClient.findByNames(selectedResult.requestedRules);
        if (ruleDetails.length === 0) {
          MessageUtil.warning({
            summary: LanguageUtil.get({ id: 'pages.sandbox.historical.errors.summary', defaultMessage: 'Rules' }),
            detail: <div>{LanguageUtil.get({ id: 'pages.sandbox.historical.errors.ruleNotFound', defaultMessage: 'Rules not found' })}</div>,
          });
        }
        let scores: Record<string, number | string> = {};
        let hitCounts: Record<string, number | string> = {};

        ruleDetails.forEach((rule) => {
          const score = this.findScoreInWorkflow(rule.workflow);
          scores[rule.name] = score || '';
        });

        const resultArray = selectedResult[user.activeRiskType] || [];
        resultArray.forEach((item: { name: string; count: number }) => {
          hitCounts[item.name] = item.count;
        });

        const ruleTableData = ruleDetails.map((rule) => ({
          name: rule.name,
          description: rule.description,
          priority: rule.priority,
          score: scores[rule.name],
          hitCount: hitCounts[rule.name] || '',
        }));
        this.setState({ ruleDetails, ruleTableData });
      } catch (e) {
        MessageUtil.error({
          summary: LanguageUtil.get({ id: 'pages.sandbox.historical.errors.summary', defaultMessage: 'Rules' }),
          detail: <div>{LanguageUtil.get({ id: 'pages.sandbox.historical.errors.ruleFetch', defaultMessage: 'An error occurred while fetching rules.' })}</div>,
        });
      }
    }
  }
}

interface RuleTableData {
  name: string;
  description?: string;
  priority?: number;
  score?: number | string;
  hitCount?: number | string;
}

interface Props {
  transactions: TransactionJsonModel[];
  user: User;
}

class State {
  selectedResult?: TestResultsResponse = undefined;
  testResults: TestResultsResponse[] = [];
  ruleDetails?: RuleJsonModel[] = undefined;
  ruleTableData: RuleTableData[] = [];
}

const mapStateToProps = (state: RootState) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(SandboxHistoricalContainer);
